export default __webpack_public_path__ + "static/media/bg.e484a647.png";